<mat-card class="invoice-card">
  <div class="row">
    <div class="col-md-7 invoiceDetails">
      <h3>
        Unibuild Uploaded Invoices ({{ invoicesData.length }})
        <span class="invoice_status" [class]="invoiceData.supplierStatus">{{
          getInvoiceStatus(invoiceData?.supplierStatus)
        }}</span>
      </h3>

      <mat-accordion multi="true">
        <mat-expansion-panel
          [expanded]="i === 0"
          *ngFor="let invoiceData of invoicesData; let i = index"
          class="invoice"
          #panel
        >
          <!-- HEADER (always visible) -->
          <mat-expansion-panel-header>
            <mat-panel-title class="flex align-items-center">
              {{ i + 1 }}. Invoice No. :
              <span class="bold">{{ invoiceData?.id }}</span>
            </mat-panel-title>

            <mat-panel-description class="header-description-1">
              Value:
              <span class="bold"
                >{{
                  invoiceData?.totalAmount?.toLocaleString("en-IN")
                }}
                INR</span
              >
            </mat-panel-description>

            <mat-panel-description class="header-description-2">
              <!-- Date: <span class="bold">{{ invoiceData?.invoiceDate | date: "MMM d, y " }}</span> -->
              <span class="oms-status" [class]="invoiceData.supplierStatus">{{
                getInvoiceStatus(invoiceData?.supplierStatus)
              }}</span>
              <span class="ml-20 margin-25">
                <lucide-icon
                  [name]="panel.expanded ? 'chevron-down' : 'chevron-right'"
                  size="18"
                >
                </lucide-icon>
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <!-- BODY (expandable content) -->
          <div class="invoice-item">
            <ng-container
              *ngIf="invoiceData?.items?.length; else noInvoiceItemTemplate"
            >
              <div class="col-md-12 flex align-items-center w100">
                <div class="invoiceForm">
                  <div class="row">
                    <div class="col-md-12">
                      <table class="invoiceTable">
                        <thead>
                          <tr>
                            <th>S.No.</th>
                            <th>Item Name</th>
                            <th>Quantity</th>
                            <th>Rate/Unit</th>
                            <th>Amount(INR)</th>
                          </tr>
                        </thead>
                        <tbody
                          class="formItem"
                          *ngFor="
                            let invoice of invoiceData.items;
                            let item = index
                          "
                        >
                          <tr>
                            <td>{{ item + 1 }}</td>
                            <td>{{ invoice.itmCode || invoice.itmName }}</td>
                            <td>{{ invoice.quantity }}</td>
                            <td>{{ invoice.customerPrice }}</td>
                            <td>{{ invoice.amount }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="invoiceItem">
                        <h4 class="medium">Invoice File</h4>
                        <div *ngFor="let file of invoiceData.file">
                          <div class="single-file flex justify-content-between" *ngIf="file.fileType !== 'Pod'">
                            <div class="flex file">
                              <div class="rfq-item rfq-icon">
                                <lucide-icon
                                  name="FileText"
                                  class="icon"
                                ></lucide-icon>
                                <h6>
                                  {{
                                    file.fileName || "Lorem Ipsum"
                                  }}
                                </h6>
                              </div>
                              <div class="info">
                                <span class="name">
                                  {{ file.fileSize || "12.08 KB" }}
                                  {{
                                    file.createdOn
                                      | date: "dd MMMM yyyy hh:mm a"
                                  }}
                                </span>
                              </div>
                            </div>
                            <span class="user">{{
                              getFileTypeLabel(file.fileType) || "Invoice"}}</span>
                            <span
                              class="rfqItem rfqDownloadIco"
                              (click)="
                                downloadInvoice(
                                  file.id,
                                  file.fileName
                                )
                              "
                            >
                              <lucide-icon
                                name="Download"
                                class="icon"
                              ></lucide-icon>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #noInvoiceItemTemplate>
              <div class="col-md-12">
                <p>No Invoice Items Found</p>
              </div>
            </ng-template>

            <!-- Attachments -->
            <div class="col-md-12">
              <div class="invoiceList">
                <ng-container
                  *ngTemplateOutlet="
                    fileList;
                    context: { $implicit: invoiceData.attachments }
                  "
                >
                </ng-container>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- <div *ngFor="let invoiceData of invoicesData; let i = index">
        <div class="flex align-items-center filesIndex">
          {{i + 1}}.
        </div>
        <div class="invoice-item">
          <div class="col-md-12 flex align-items-center w100">
            <div class="invoiceForm">
              <div class="row">
                <div class="col-md-5">
                  <div class="formGroup">
                    <label class="flex">Invoice No.</label>
                    <div class="inputValue">
                      {{ invoiceData?.invoiceNo }}
                    </div>
                  </div>
                </div>
                <div class="col-md-7">
                  <div class="formGroup">
                    <label class="flex">Total Amount <span *ngIf="invoiceData?.currency">({{invoiceData?.currency}})</span></label>
                    <div class="inputValue">{{ invoiceData?.totalAmount }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="invoiceList">
              <ng-container *ngTemplateOutlet="fileList; context: { $implicit: invoiceData.attachments }"></ng-container>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</mat-card>

<ng-template #fileList let-filesData>
  <div class="invoiceItem" *ngFor="let files of filesData; let i = index">
    <h5 class="medium">{{ getFileTypeLabel(files.fileType) }}</h5>
    <div class="single-file flex justify-content-between">
      <div class="flex file">
        <div class="rfq-item rfq-icon">
          <lucide-icon name="FileText" class="icon"></lucide-icon>
          <h6>{{ files.fileName }}</h6>
        </div>
        <div class="info">
          <span class="name">
            {{ files.fileSize }}
            {{ files.createdOn | date: "dd MMMM yyyy hh:mm a" }}
          </span>
        </div>
      </div>
      <span class="user">{{ getFileTypeLabel(files.fileType) }}</span>
      <span
        class="rfqItem rfqDownloadIco"
        (click)="downloadInvoice(files.id, files.fileName)"
      >
        <lucide-icon name="Download" class="icon"></lucide-icon>
      </span>
    </div>
  </div>
</ng-template>
